/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedSupplierProductList } from '../../models/paginated-supplier-product-list';

export interface SupplierProductsList$Params {
  catalogue?: number;
  category?: Array<number>;
  currency?: Array<'CHF' | 'EUR' | 'USD'>;
  facilities?: Array<number>;
  newest_only?: boolean;
  newest_product_version?: number;

/**
 * Multiple values may be separated by commas.
 */
  no_id?: Array<number>;

/**
 * Which field to use when ordering the results.
 */
  ordering?: string;

/**
 * A page number within the paginated result set.
 */
  page?: number;

/**
 * Number of results to return per page.
 */
  page_size?: number;

/**
 * A search term.
 */
  search?: string;
  tags?: Array<number>;
}

export function supplierProductsList(http: HttpClient, rootUrl: string, params?: SupplierProductsList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedSupplierProductList>> {
  const rb = new RequestBuilder(rootUrl, supplierProductsList.PATH, 'get');
  if (params) {
    rb.query('catalogue', params.catalogue, {});
    rb.query('category', params.category, {"style":"form","explode":true});
    rb.query('currency', params.currency, {"style":"form","explode":true});
    rb.query('facilities', params.facilities, {"style":"form","explode":true});
    rb.query('newest_only', params.newest_only, {});
    rb.query('newest_product_version', params.newest_product_version, {});
    rb.query('no_id', params.no_id, {"style":"form","explode":false});
    rb.query('ordering', params.ordering, {});
    rb.query('page', params.page, {});
    rb.query('page_size', params.page_size, {});
    rb.query('search', params.search, {});
    rb.query('tags', params.tags, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedSupplierProductList>;
    })
  );
}

supplierProductsList.PATH = '/msp/api/supplier/products/';
